/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  HiddenMcpServer,
  HiddenMcpServer$inboundSchema,
} from "./hiddenmcpserver.js";

export type ListHiddenMcpServersResult = {
  /**
   * Hidden servers, oldest first.
   */
  servers: Array<HiddenMcpServer>;
};

/** @internal */
export const ListHiddenMcpServersResult$inboundSchema: z.ZodMiniType<
  ListHiddenMcpServersResult,
  unknown
> = z.object({
  servers: z.array(HiddenMcpServer$inboundSchema),
});

export function listHiddenMcpServersResultFromJSON(
  jsonString: string,
): SafeParseResult<ListHiddenMcpServersResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListHiddenMcpServersResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListHiddenMcpServersResult' from JSON`,
  );
}
